import { jsx as _jsx } from "react/jsx-runtime";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NewButton } from "@helium10/re-ui-components";
import styled, { css } from "styled-components";
export const ActionsWithCard = ({ isLoading, isComplete, isSubmitting, buttonDefaultText, buttonSubmittingText, buttonCompleteText, }) => {
    const isSubmittingText = isSubmitting && buttonSubmittingText;
    const isCompleteText = isComplete && buttonCompleteText;
    return (_jsx(Container, { children: _jsx(ProcessButton, { "$size": "400", "$isComplete": !!isComplete, "$buttonType": isComplete ? "secondary" : "primary", icon: isLoading && _jsx(FontAwesomeIcon, { spin: true, icon: faSpinner }), disabled: isLoading || isSubmitting || isComplete, children: isLoading && !isSubmitting
                ? ""
                : isCompleteText || isSubmittingText || buttonDefaultText || "" }) }));
};
const Container = styled.div `
  order: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${(p) => `${p.theme.spacing.sp16} 0 0 0`};
`;
const ProcessButton = styled(NewButton) `
  min-width: 224px;

  ${(p) => p.$isComplete &&
    css `
      cursor: initial;
      background: #def8e6;
      border-color: #def8e6;
      color: #217c49;

      &:hover,
      &:focus,
      &:active,
      &:disabled {
        border-color: #def8e6;
        color: #217c49;
        opacity: 1;
      }
    `}
`;
